import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback || (
        <div className="p-3 rounded-lg border border-amber-200 bg-amber-50 text-xs text-amber-700">
          <p className="font-semibold">Component failed to load</p>
          <p className="mt-1 text-amber-600">{this.state.error?.message || 'An unexpected error occurred'}</p>
          <button className="mt-2 text-primary underline" onClick={() => this.setState({ hasError: false, error: null })}>Retry</button>
        </div>
      );
    }
    return this.props.children;
  }
}
